/**
 * Formats an Icelandic phone number by:
 * 1. Removing +354 prefix if present
 * 2. Adding a dash after the first 3 digits
 *
 * @param {string} phoneNumber - The phone number to format
 * @returns {string} - The formatted phone number
 *
 * @example
 * formatPhoneNumber("+3541234567") // returns "123-4567"
 * formatPhoneNumber("1234567") // returns "123-4567"
 * formatPhoneNumber("123456") // returns "123456" (unchanged if not 7 digits)
 */
export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "";

    // Remove +354 prefix if present
    let formattedNumber = phoneNumber.replace(/^\+354/, "");

    // Add dash after first 3 digits if number is 7 digits long
    if (formattedNumber.length === 7) {
        formattedNumber = `${formattedNumber.slice(0, 3)}-${formattedNumber.slice(3)}`;
    }

    return formattedNumber;
};
